import { useEffect, useState } from "react"
import { Link, NavLink } from "react-router-dom"
import axiosInstance from "../../hooks/axiosInstance"
import { toast } from "react-toastify"
import { Pagination } from "@mui/material"
import Details from "../../components/Member/Profile/Details"
import { Button, Modal } from "react-bootstrap"
import SendInvitation from "../../components/AssociationAdmin/SendInvitation"
import EditMemberInfo from "../../components/AssociationAdmin/EditMemberInfo"
import UploadMember from "../../components/AssociationAdmin/UploadMember"

export default function MembersListPage() {
    const [loading, setLoading] = useState(false)
    const [members, setMembers] = useState([])
    const [currentMember, setCurrentMember] = useState(null)
    const [inviteOpen, setInviteOpen] = useState(false)
    const [uploadOpen, setUploadOpen] = useState(false)
    const [membershipIdOpen, setMembershipIdOpen] =  useState(false)
    const [refreshKey, setRefreshKey] = useState(0)

    const [filter, setFilter] = useState({
        search: '', status: ''
    })


    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFilterChange = (e) => {
        const {name, value} = e.target

    setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const refreshPage = () => {
        setRefreshKey(prevRefreshKey => prevRefreshKey + 1)
    }

    const fetchAssociationMembers = () => {
        setLoading(true)
        axiosInstance.post(`/association/associations/members?page=${page}`, filter)
              .then(response => {
                setMembers(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    const handleInviteClose = () => {
        setInviteOpen(false)
    }

    useEffect(() => {
        fetchAssociationMembers()
    }, [page, refreshKey])

    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Members</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Members</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            <div className="row" id="contactList">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex align-items-center border-0">
                            <h5 className="card-title mb-0 flex-grow-1">Members List</h5>
                            <div className="flex-shrink-0">
                                <div className="flax-shrink-0 hstack gap-2">
                                    {/* <button className="btn btn-primary">Today's Orders</button> */}
                                    <button className="btn btn-soft-info" onClick={() => setInviteOpen(true)}>
                                        <i className="bi bi-plus me-2"></i>
                                        Invite Member
                                    </button>
                                    <button className="btn btn-soft-primary" onClick={() => setUploadOpen(true)}>
                                        <i className="bi bi-plus me-2"></i>
                                        Upload Bulk Member
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="row g-2">
                                <div className="col-xl-4 col-md-6">
                                    <div className="search-box">
                                        <input type="text" 
                                            className="form-control search" 
                                            placeholder="Search members..." 
                                            name="search"
                                            value={filter.search}
                                            onChange={handleFilterChange}
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-md-4">
                                    <select 
                                        className="form-control" 
                                        name="status" 
                                        value={filter.status}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Select Membership Status</option>
                                        <option value="active">Active</option>
                                        <option value="expired">Expired</option>
                                        {/* <option value="Pending">Pending</option> */}
                                    </select>
                                </div>
                                {/* <!--end col--> */}
                                <div className="col-xl-1 col-md-4">
                                    <button className="btn btn-success w-100" onClick={fetchAssociationMembers}>Filter</button>
                                </div>
                            </div>
                            {/* <!--end row--> */}
                        </div>
                        <div className="card-body">
                            {members.length > 0 && (
                                <>
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle table-nowrap" id="customerTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th className="sort" data-sort="currency_name" scope="col">Member Info</th>
                                                    {/* <th className="sort" data-sort="type" scope="col">Membership Type</th> */}
                                                    <th className="sort" data-sort="quantity_value" scope="col">Membership ID</th>
                                                    <th className="sort" data-sort="level" scope="col">Membership Level</th>
                                                    <th className="sort" data-sort="time" scope="col">Date Joined</th>
                                                    {/* <th className="sort" data-sort="status" scope="col">Status</th> */}
                                                    <th className="sort" data-sort="status" scope="col">Membership Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            {/* <!--end thead--> */}
                                            <tbody className="list form-check-all">
                                                {members.map(member => (
                                                    <tr key={member.id}>
                                                        <td className="id" style={{display:"none"}}><a href="javascript:void(0);" className="fw-medium link-primary">#VZ001</a></td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-shrink-0">
                                                                    <img src="/assets/images/users/avatar-3.jpg" alt="" className="avatar-xs rounded-circle" />
                                                                </div>
                                                                <a data-bs-toggle="offcanvas" data-bs-target="#member-view-offcanvas" className="flex-grow-1 ms-2 currency_name cursor-pointer">
                                                                    <span className="m-0 text-capitalize">{member.user?.title}. {member.user?.last_name} {member.user?.first_name} {member.user?.middle_name}</span>
                                                                    <p className="m-0 text-muted" style={{lineHeight: 1.5}}>{member.user?.email}</p>
                                                                </a>
                                                            </div>
                                                        </td>
                                                        {/* <td className="type text-success">Free</td> */}
                                                        <td className="id fw-medium link-primary">
                                                            <div className="d-flex gap-3">
                                                                {member.membership_id ? member.membership_id : '-'}
                                                                <a href="#" className="link-danger font-weight-bolder cursor-pointer" onClick={() => {setCurrentMember(member); setMembershipIdOpen(true)}}>
                                                                    <i className="ri-edit-box-line"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td className="order_date level">
                                                           -
                                                           {/* <a href="#" className="link-danger font-weight-bolder cursor-pointer"><i className="ri-edit-box-line"></i></a> */}
                                                        </td>
                                                        <td className="order_date time" data-timestamp="1641945600">
                                                            {member.joined_on}
                                                        </td>
                                                        <td className="status">
                                                            <span 
                                                                className={`badge ${member.status == 'active' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}
                                                            >{member.status}</span>
                                                        </td>
                                                        <td>
                                                            <div className="dropdown">
                                                                <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="ri-more-fill"></i>
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    <li onClick={() => setCurrentMember(member)} data-bs-toggle="offcanvas" data-bs-target="#member-view-offcanvas"><a className="dropdown-item cursor-pointer"><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View Profile</a></li>
                                                                    {/* <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-star-fill text-muted me-2 align-bottom"></i>Renew Membership</a></li> */}
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            {/* <!--end tr--> */}
                                            </tbody>
                                        </table>
                                        {/* <!--end table--> */}
                                        <div className="noresult" style={{display: "none"}}>
                                            <div className="text-center">
                                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                                <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                                        {/* <div className="col-sm-6">
                                            <div>
                                                <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                                            </div>
                                        </div> */}
                                        {/* <!-- end col --> */}
                                        <div className="col-sm-12 d-flex justify-content-end mt-4">
                                            <Pagination 
                                                onChange={handlePageChange}  
                                                count={pageCount} 
                                                color="primary" 
                                                shape="rounded"
                                                size="small"
                                                page={page}
                                            />
                                        </div>
                                        {/* <!-- end col --> */}
                                    </div>
                                </>
                            )}
                            {members.length == 0 && (
                                <div className="noresult">
                                    <div className="text-center">
                                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                        <h5 className="mt-2">Sorry! No Result Found</h5>
                                        {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <!--end card--> */}
                </div>
                {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}


            {/* <!-- Member View --> */}
            <div className="offcanvas offcanvas-end border-0" tabindex="-1" id="member-view-offcanvas">
                <div className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header">
                    <h5 className="m-0 me-2 text-white">Member Profile</h5>

                    <button type="button" className="btn-close btn-close-white ms-auto" id="customizerclose-btn"
                        data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body p-0 bg-light">
                    <div data-simplebar className="h-100">
                        <div className="p-4">
                            <Details userId={currentMember?.user_id}/>
                        </div>
                    </div>
                </div>
            </div>

            {/* Send Invite Modal */}
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={inviteOpen} onHide={handleInviteClose}
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title id="contained-modal-title-vcenter">
                        Send Invitation
                    </Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    <SendInvitation close={handleInviteClose}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-light" onClick={() => setInviteOpen(false)}>Close</Button>
                </Modal.Footer>
            </Modal>

            {/* Edit Membership ID Modal */}
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={membershipIdOpen} onHide={() => setMembershipIdOpen(false)}
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title id="contained-modal-title-vcenter">
                        Send Invitation
                    </Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    <EditMemberInfo member={currentMember} refreshPage={refreshPage} close={() => setMembershipIdOpen(false)}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-light" onClick={() => setMembershipIdOpen(false)}>Close</Button>
                </Modal.Footer>
            </Modal>

            {/* Bulk Member Add Modal */}
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={uploadOpen} onHide={() => setUploadOpen(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Upload New Members
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UploadMember refetchData={refreshPage} close={() => setUploadOpen(false)}/>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button className="btn-light" onClick={() => setUploadOpen(false)}>Close</Button>
                </Modal.Footer> */}
            </Modal>
        </>
    )
}